'use es6';

import { reducePromotionsResponse } from 'pricing-pages-lib/reducers/Promotions';
import { FetchPromotionsRequestTypes } from '../actions/PromotionActions';
const initialState = {};

const Promotions = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case FetchPromotionsRequestTypes.RECEIVE:
      {
        const {
          data
        } = payload;
        return reducePromotionsResponse(data);
      }

    default:
      return state;
  }
};

export default Promotions;